<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置图像数据格式</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			视频人脸检测支持YUV图像格式的NV21和NV12格式，默认使用NV21格式。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceSetYUVFormat(int Format)</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">int类型，0：YUV_NV12，1：YUV_NV21，默认（不设置）使用NV21格式。</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String UID = skFace.SKFaceSetYUVFormat(0); //设置YUV图像格式为NV12</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','拓展接口','设置图像数据格式'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/expand/SettingImageFormat.vue